import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/img/IS_Planner.svg'


const _withScopeId = n => (_pushScopeId("data-v-82d89da2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "menu navbar" }
const _hoisted_2 = { class: "navbar__wrapper" }
const _hoisted_3 = {
  key: 0,
  class: "navbar__menu"
}
const _hoisted_4 = { class: "navbar__user" }
const _hoisted_5 = { class: "navbar__language" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-globe" }, null, -1))
const _hoisted_7 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_dropdownui = _resolveComponent("dropdownui")!
  const _component_User = _resolveComponent("User")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        class: "logo",
        src: _imports_0,
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goRootPage && _ctx.goRootPage(...args)))
      }),
      (!_ctx.isRouteLoginRegisterRecoveryUserUndefined && _ctx.isValidPath)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("button", {
              class: _normalizeClass({'navbar__menu--active': _ctx.currentRoute === _ctx.RouterPaths.Plants || _ctx.currentRoute === _ctx.RouterPaths.Sizings
        || _ctx.currentRoute === _ctx.RouterPaths.NewSizing || _ctx.currentRoute === _ctx.RouterPaths.SizingReport || _ctx.currentRoute === _ctx.RouterPaths.NewPlant}),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goToPath('/general/plants')))
            }, _toDisplayString(_ctx.$t('menu.plants')), 3),
            _createElementVNode("button", {
              class: _normalizeClass({'navbar__menu--active': _ctx.currentRoute === _ctx.RouterPaths.Inverters}),
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.goToInverters('/general/inverters')))
            }, _toDisplayString(_ctx.$t('menu.inverters')), 3),
            _createElementVNode("button", {
              class: _normalizeClass({'navbar__menu--active': _ctx.currentRoute === _ctx.RouterPaths.PVModules}),
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.goToPath('/general/pvmodules')))
            }, _toDisplayString(_ctx.$t('menu.pvmodel')), 3)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          (_ctx.languages.length > 0)
            ? (_openBlock(), _createBlock(_component_dropdownui, {
                key: 0,
                selected: _ctx.languagepicked,
                values: _ctx.languages,
                onValueSelected: _ctx.setLanguage,
                styleClass: 'pvmodulemanufacturer__dropdown'
              }, null, 8, ["selected", "values", "onValueSelected"]))
            : _createCommentVNode("", true)
        ]),
        (_ctx.isUserLogged)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createVNode(_component_User)
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}